export default __webpack_public_path__ + "static/media/DAIF_Services_Screen4_in-end.b1c3f73d.jpg";